var Cleverly = function(){

    var _confirm = function(response){

        $("#confirm-title").html(response.title);
        $("#confirm-title")
            .parent()
            .removeClass('text-white')
            .removeClass(function (index, className) {
                return (className.match (/(^|\s)bg-\S+/g) || []).join(' ');
            })
            .addClass(response.headerClasses);
        $("#confirm-text").html(response.content);
        $("#button-clever").html(response.btnText).prop("disabled", response.btnDisabled);
        if(typeof response.dataJson == 'object'){
            $.each(response.dataJson,function(key, value){
                Debug.log('set data-'+key+' to ',value);
                $("#button-clever")
                    .removeAttr('data-'+key)
                    .attr("data-"+key,value );
            });
        }
        if(response.btnShow==true){
            $("#button-clever")
                .removeClass("d-none")
                .attr("data-next",response.next)
                .removeAttr('data-action')
                .attr("data-action",response.action);
        }else{
            $("#button-clever").addClass("d-none").attr("data-next",null);
        }
    
    };

    var _reset = function(){
        $("#confirm-title").html('')
            .parent()
            .removeClass(function (index, className) {
                return (className.match (/\bbg-\S+/g) || []).join(' ');
            })
            .removeClass("text-white");
        $("#confirm-text").html('');
        $("#button-clever").html('')
            .prop("disabled", true)
            .removeData("json").removeAttr("data-json")
            .removeData("next").removeAttr("data-next")
            .addClass("d-none");
    };

    return {
        Confirm: function(r){
            _confirm(r);
        },
        Reset: function(){
            _reset();
        }
    }

}();

var Do = function(){
    
    var _ajax = function(route,packet,withHeaders){
    
        if( withHeaders !== false ){
    
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
    
        }
    
        $.ajax({
            url:        route,
            type:       typeof packet._method == 'undefined' ? 'POST' : packet._method,
            cache:      false,
            dataType:   'json',
            data:       packet,
            success:    function(returned){
                msg = returned.action.message;
                if( returned.outcome=='FAIL'){
                    Do.Callback( msg.callback, msg.with );
                    if(typeof returned.action.route !== "undefined"){
                        setTimeout(function(){  window.location.href=returned.action.route; }, msg.with.delay);
                    }
                }
                if( returned.outcome=='PASS'){
                    if(msg.callback.length){
                        Do.Callback( msg.callback, msg.with );
                    }
                    if(typeof returned.action.route !== 'undefined'){
                        setTimeout(function(){  window.location.href=returned.action.route; }, msg.with.delay);
                    }
                }
            },
            error: function(data){
                returned = data.responseJSON;
                var content;
                $.each( returned.errors, function( key, value ) {
                    $('#error-'+key).html('<span class="form-text text-danger"><i class="icon-cancel-circle2 mr-2"></i>'+value[0]+'</span>');
                    content = value[0];
                });
                alert( content );
            }
        });
    }

    var _callback = function( callback, args ){
        if(Array.isArray(callback)){
            Debug.log('preparing Array callback',callback);
            var instance = this[callback[0]];
            var method = callback[1];
            return instance[method](args);
           
        }else{
            Debug.log('preparing String callback ',callback);
            return this[callback](args);
        }
    }

    var _notyfi = function(args){
        new Noty({
                theme: ' alert alert-'+args.class+' alert-styled-left p-0 bg-white',
                layout: 'center',
                text: args.content,
                type: args.class,
                progressBar: true,
                timeout: args.delay
        }).show();

    }

    var _login = function(){
        Do.Callback( ["Do","Notify"], {
            class:'danger',
            content:"You're not logged in!",
            delay:500,
        } );
        setTimeout(function(){  window.location.href=window.location.href; }, 500);
    }

    return {
        Ajax: function(r,p,h){
            _ajax(r,p,h)
        },
        Callback: function(c,a){
            _callback(c,a);
        },
        Notify: function(a){
            _notyfi(a);
        },
        Login: function(){
            _login();
        }
    }
}();

var Popups = function () {
    // Custom tooltip color
    var _tooltipCustomColor = function() {
		$('[data-popup=tooltip-custom]').tooltip({
			template: '<div class="tooltip"><div class="arrow border-teal"></div><div class="tooltip-inner bg-teal text-white"></div></div>'
		});
    };

    return {
        init: function() {
            _tooltipCustomColor();
        }
    }
}();

var Legals = function () {

    var _remoteLegalRender = function() {
        $("#modal_legal_terms").on("show.bs.modal", function() {
            $(this).find(".modal-body").load("/terms-of-service");
        });
        $("#modal_legal_privacy").on("show.bs.modal", function() {
            $(this).find(".modal-body").load("/privacy-policy");
        });
    };

    return {
        init: function() {
            _remoteLegalRender();
        }
    }
}();

var FormLayouts = function() {

    // Uniform
    var _componentUniform = function() {
        if (!$().uniform) {
            console.warn('Warning - uniform.min.js is not loaded.');
            return;
        }

        // Initialize
        $('.form-input-styled').uniform({
            fileButtonClass: 'action btn btn-light'
        });
    };

    return {
        init: function() {
            // _componentSelect2();
            _componentUniform();
        }
    }
}();

document.addEventListener("DOMContentLoaded", function() {
    Legals.init();
    Popups.init();
    FormLayouts.init();
});
